import request from "./request.js";
/* global google */


const baseUrl = process.env.NODE_ENV == "development" ? "https://www.livepolls.app/collaborative_whiteboard" : "https://www.livepolls.app/collaborative_whiteboard";
export function getPassport() {
  return request({
    url: baseUrl + "/api/user/passport",
    data: {
    
    },
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    }
  })
}
export function getAddonUserStatus(passport) {
  const header = {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    "X-Access-Ticket": passport,
  }
  return request({
    url: baseUrl + "/api/user/status",
    method: "POST",
    headers: header
  })
}

let isCollecting = false;
export function loginAddon() {
  if(google){
    return new Promise((resolve, reject) => {
      return resolve("")
    })
  }
}

export function collectEmail(email) {
  return request({
    url: baseUrl + "/api/user/email-collect",
    data: {
      email,
      channel: `ai_slide_generator`
    },
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    }
  })
}